import React, { FC } from 'react';
import { Button, Box as Wrapper, Text } from '@tonic-ui/react';
import { Modal } from '../../components/modal';
import { useTranslation } from 'react-i18next';

interface MarketplaceDismissModalProps {
  submitModal: () => void;
  onClose: () => void;
  providerName: string;
  isOpen: boolean;
}

const MarketplaceDismissModal: FC<MarketplaceDismissModalProps> = ({
  submitModal,
  onClose,
  providerName,
  isOpen,
}) => {
  const { t } = useTranslation();

  const returnToAccountSelection = (_) => submitModal();

  return (
    <Modal
      id="marketplace-dismiss"
      isOpen={isOpen}
      onClose={onClose}
      closeOnOutsideClick={false}
      size="sm"
      header={t('marketplaceModal.title')}
      body={
        <Wrapper mt="13px">
          <Text size="sm" lineHeight="sm" mb="15px">
            {t(`marketplaceModal.description.${providerName}.first`)}
          </Text>
          <Text size="sm" lineHeight="sm" mb="15px">
            {t(`marketplaceModal.description.${providerName}.second`)}
          </Text>
          <Text size="sm" lineHeight="sm">
            {t(`marketplaceModal.description.${providerName}.third`)}
          </Text>
        </Wrapper>
      }
      footer={
        <>
          <Button variant="primary" minWidth={64} onClick={returnToAccountSelection}>
            {t('marketplaceModal.button.primary')}
          </Button>
          <Button width="fit-content" marginLeft={23} onClick={onClose}>
            {t('marketplaceModal.button.secondary')}
          </Button>
        </>
      }
    />
  );
};

MarketplaceDismissModal.displayName = 'MarketplaceDismissModal';
export default MarketplaceDismissModal;
